import { groq } from 'next-sanity'
import materialCategory from './materialCategory'

//image
export const fields = groq`
  title,
  slug,
  materialCategory->{${materialCategory.fields}}
`

export const fragment = (name = 'material') => `${name}{ ${fields} }`

const exports = { fields, fragment }

export default exports
